module.exports = __webpack_public_path__ + "img/ROCKET.b6c7bd9a.svg";